import React, { useContext, useEffect, useState } from 'react';

import CandidatesDropdown from '../Header/CandidatesDropdown';
import Tabs from './Tabs';

import { SearchContext } from '../../../context/SearchContext';
import useDebouncedSearchWithHistory from '../../../hooks/useDebouncedSearchWithHistory';
import classes from './styles.module.scss';

export default function Search() {
  const [isFocused, setIsFocused] = useState(false);
  const [currentSearchTerm, setCurrentSearchTerm] = useState('');
  const [currentActiveDropDownOption, setCurrentActiveDropDownOption] =
    useState('All');

  const {
    searchTerm,
    setSearchTerm,
    activeDropDownOption,
    isOpenedSearchScreen,
    setIsOpenedSearchScreen,
    activeSearchScreenTab,
    setActiveSearchScreenTab,
  } = useContext(SearchContext);

  const { searchHistory } = useDebouncedSearchWithHistory(
    searchTerm,
    'globalSearchHistory'
  );

  useEffect(() => {
    if (isOpenedSearchScreen) {
      setCurrentSearchTerm(searchTerm);
      setCurrentActiveDropDownOption(activeDropDownOption);
      setIsOpenedSearchScreen(false);
      setSearchTerm('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenedSearchScreen]);

  return (
    <div className={classes.SearchScreen}>
      <div className={classes.search}>
        <div className={classes.inputContainer}>
          <input
            type="text"
            placeholder="Search"
            value={currentSearchTerm}
            onChange={(event) => setCurrentSearchTerm(event.target.value)}
            onFocus={() => setIsFocused(true)}
            onBlur={() => {
              setTimeout(() => {
                setIsFocused(false);
              }, 150);
            }}
          />
          {currentSearchTerm && (
            <button type="button" onClick={() => setCurrentSearchTerm('')}>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="32" height="32" rx="16" fill="#F2F4F8" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15.9142 15.0252L19.9194 11.02C20.2123 10.7271 20.6872 10.7271 20.9801 11.02C21.273 11.3129 21.273 11.7877 20.9801 12.0806L16.9749 16.0858L20.9801 20.091C21.273 20.3839 21.273 20.8588 20.9801 21.1517C20.6872 21.4446 20.2123 21.4446 19.9194 21.1517L15.9142 17.1465L11.909 21.1517C11.6161 21.4446 11.1412 21.4446 10.8483 21.1517C10.5554 20.8588 10.5554 20.3839 10.8483 20.091L14.8535 16.0858L10.8483 12.0806C10.5554 11.7877 10.5554 11.3129 10.8483 11.02C11.1412 10.7271 11.6161 10.7271 11.909 11.02L15.9142 15.0252Z"
                  fill="#242833"
                />
              </svg>
            </button>
          )}
        </div>
        {isFocused && searchHistory.length ? (
          <ul className={classes.searchHistory}>
            {searchHistory.map((record) => (
              // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
              <li key={record} onClick={() => setCurrentSearchTerm(record)}>
                {record}
              </li>
            ))}
          </ul>
        ) : null}
        <div className={classes.selectorContainer}>
          <CandidatesDropdown
            activeDropDownOption={currentActiveDropDownOption}
            setActiveDropDownOption={setCurrentActiveDropDownOption}
          />
        </div>
      </div>

      <span className={classes.searchText}>{currentSearchTerm}</span>

      <Tabs
        searchTerm={currentSearchTerm}
        activeDropDownOption={currentActiveDropDownOption}
        currentTab={activeSearchScreenTab}
        setCurrentTab={setActiveSearchScreenTab}
      />
    </div>
  );
}
